import {
	Component,
	inject,
	OnInit,
	CUSTOM_ELEMENTS_SCHEMA,
	NO_ERRORS_SCHEMA
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

import { SHARED_IMPORTS } from '../shared/shared-imports';
import { SdmGlobal } from '../../config/config';
import { Auth0Service } from '../../services/auth0.service';

@Component({
	selector: 'user-onboard-component',
	standalone: true,
	templateUrl: 'components/user-onboard/user-onboard.component.html',
	imports: [...SHARED_IMPORTS, MatFormFieldModule, MatInputModule, MatIconModule, MatCardModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UserOnboardComponent implements OnInit {
	public userName = '';
	public password = '';
	public invitation: any;
	private extId: string;

	private http = inject(HttpClient);
	private auth0Service = inject(Auth0Service);
	private route = inject(ActivatedRoute);

	constructor() {
		// Get invitation ID from Angular Router params instead of UI-Router $stateParams
		this.extId = this.route.snapshot.params['invitationExternalId'];
	}

	ngOnInit(): void {
		this.http.get(`/public/ExternalLink/GetInvitation/${this.extId}`)
			.subscribe((res: any) => {
				this.invitation = res;
				this.userName = this.invitation.Email;
			});
	}

	signUp(): void {
		// Note: Modern Auth0 SDK doesn't support direct signup with username/password
		// This functionality may need to be implemented differently or removed
		console.warn('User signup functionality needs to be reimplemented with modern Auth0 SDK');
		
		// For now, redirect to Auth0 hosted signup page
		// We'll use the regular login which should allow signup if enabled in Auth0
		this.auth0Service.loginRegular();
	}
}
